var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ChartObject } from './chart-init-objects';
import { ScaleService } from './scale.service';
import { AxesService } from './axes.service';
import { SvgService } from './svg-service';
import { ChartDimensions } from './chart-dimensions';
import { HtmlPopup } from '../../pages/shared/html/html-popup';
export class GraphControllerV3 {
    constructor(slug, page, group, mapping, segment) {
        this.slug = slug;
        this.page = page;
        this.group = group;
        this.mapping = mapping;
        this.segment = segment;
        this.scales = {};
        this.axes = {};
        this.config = { margin: { top: 0, bottom: 0, left: 0, right: 0 }, padding: { top: 0, bottom: 0, left: 0, right: 0 }, scales: [], axes: [], extra: {} };
    }
    init() {
    }
    _init() {
        let self = this;
        let chartObject = ChartObject();
        this.config = Object.assign(chartObject.config(), this.config);
        this.dimensions = chartObject.dimensions();
        this.svg = chartObject.svg();
        return;
    }
    _html(altWrapper) {
        this.element = (altWrapper == undefined) ? window.d3.select(this.group.element).node() : window.d3.select(altWrapper).node();
        const graphEl = document.createElement('section');
        graphEl.classList.add("graph-container-12");
        graphEl.classList.add("graph-view");
        this.element.appendChild(graphEl);
        if (this.element != null && this.mapping.description && this.mapping.description !== '') {
            this.popup = new HtmlPopup(this.element, this.mapping.description);
        }
        return graphEl;
    }
    _svg(svgWrapper) {
        return __awaiter(this, void 0, void 0, function* () {
            // with elementID we can create a child element as svg container with a fixed height. 
            this.element = window.d3.select(svgWrapper ? svgWrapper : this.element).node();
            if (this.element == null)
                return;
            this.chartDimensions = new ChartDimensions(this.element, this.config);
            this.dimensions = this.chartDimensions.measure(this.dimensions);
            this.svgService = new SvgService(this.element, this.config, this.dimensions, this.svg);
            for (let c of this.config.scales) {
                this.scales[c.slug] = new ScaleService(this, c);
            }
            for (let c of this.config.axes) {
                this.axes[c.slug] = new AxesService(this, c);
            }
            return;
        });
    }
    redraw(data, range) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.svg && this.svg.body == undefined)
                return;
            this.dimensions = this.chartDimensions.measure(this.dimensions);
            this.svgService.redraw(this.dimensions);
            if (this.config.scales) {
                for (let c of this.config.scales) {
                    this.scales[c.slug].reset();
                }
            }
            for (let a of this.config.axes) {
                this.axes[a.slug].redraw(this.dimensions, this.scales[a.scale].scale, data.slice);
            }
            return;
        });
    }
    draw(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    prepareData(data) {
        return data;
    }
    update(data, segment, update) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    _update(newData, segment, update, range) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            if (update && this.config.extra.noUpdate) {
                return;
            }
            if (this.popup && this.mapping.description) {
                this.popup.attachData(newData);
            }
            this.segment = segment;
            const data = self.prepareData(newData);
            // //  needed within multiples .. why ??? 
            this.preparedData = Object.assign({}, data);
            yield self.draw(this.preparedData);
            yield self.redraw(this.preparedData, range);
            window.addEventListener("resize", () => self.redraw(this.preparedData), false);
            if (this.mapping.segmentIndicator) {
                this.htmlSegment.draw(segment);
            }
            return;
        });
    }
    _addScale(slug, type, direction, parameter) {
        this.config.scales.push({
            slug,
            type,
            direction,
            parameter
        });
    }
    _addAxis(slug, scale, position, format, extra, label) {
        this.config.axes.push({
            slug,
            scale,
            position,
            format,
            extra,
            label
        });
    }
    _addMargin(top, bottom, left, right) {
        this.config.margin = {
            top,
            bottom,
            left,
            right
        };
    }
    _addPadding(top, bottom, left, right) {
        this.config.padding = {
            top,
            bottom,
            left,
            right
        };
    }
}
